function setDataUnloading({ state }) {
  state.set('app.data.loading', false)
}

export default setDataUnloading



// WEBPACK FOOTER //
// ./src/modules/user/actions/setDataUnloading.js